export default __webpack_public_path__ + "static/media/javascript-javascript-futurama.e18cf990.jpg";